export { default } from './ModulButlleti';
